import { createActions } from "redux-actions";

export const { setAdminOpenedNodes, setCompanyNetwork } = createActions({
  SET_ADMIN_OPENED_NODES: ({ items }) => ({ items }),
  SET_COMPANY_NETWORK: ({ items }) => ({ items }),
});
